export default __webpack_public_path__ + "static/media/rivet-header.375c7036.svg";